import React from 'react';
import Business from '../components/sections/Business';
import PageHeader from '../components/ui/PageHeader';
import './StaticPage.css';

const BusinessPage: React.FC = () => (
  <div className="static-page">
    <PageHeader page="business" />
    <Business />
  </div>
);

export default BusinessPage;
